import React, { cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../Button/Button';
import Icon from '../Icon/Icon';

const renderHeaderChildren = (children, id) => {
  if (typeof children === 'string') {
    return (
      <h2 className="c-modal__heading" id={id}>
        {children}
      </h2>
    );
  }
  return cloneElement(children, {
    ...children.props,
    className: cn('c-modal__heading', children.props?.className || ''),
    id,
  });
};

const CloseButton = ({ className, onClick }) => <Button
    className={cn('c-modal__close', className)}
    color="subtle"
    data-testid="modal-close"
    onClick={onClick}
  >
    <Icon className="c-modal__icon" icon="close" title="Close" />
  </Button>

const ModalHeader = ({ children, className, id, onClick, ...rest }) => {
  const classes = cn('c-modal__header', className);
  return (
    <div className={classes} {...rest}>
      {renderHeaderChildren(children, id)}
      <CloseButton onClick={onClick} />
    </div>
  );
};

ModalHeader.part = 'modal-header';

ModalHeader.CloseButton = CloseButton;

export default ModalHeader;

ModalHeader.propTypes = {
  children: PropTypes.oneOfType([
    (props, propName) => {
      const prop = props[propName];
      if (Children.count(prop !== 1)) {
        return new Error('Modal header can only accept one child');
      }
    },
    PropTypes.node,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ModalHeader.defaultProps = {
  children: null,
  className: '',
};
